import React from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { Link } from 'react-router-dom';
import { auth, firestore } from '../../firebase';
import "./ChatRoomsList.css";

const ChatRoomsList = () => {
    const currentUser = auth.currentUser;
    
    const usersInfoRef = firestore.collection('usersInfo');
    const [usersInfo] = useCollectionData(usersInfoRef, {idField: "id"});
    const roomsIdList = usersInfo && usersInfo.filter(user => user.id === currentUser.uid)[0].rooms;

    const chatRoomsListRef = firestore.collection("chatRoomsList");
    let [roomsList] = useCollectionData(chatRoomsListRef, {idField: "id"});
    console.log("!!!", roomsList);
    roomsList = roomsList && roomsIdList.map(id => {
        const room = roomsList.filter(room => {
            return room.id === id
        })
        return room[0];
    })
    console.log("Rooms list:", roomsList);
    

    return (
        <div className="chat-room-list-box">

            {roomsList &&
                roomsList.map((room) => {
                    return (
                        <div key={room.id} className="chat-room-list">
                            <Link to={`/chatRoom/${room.id}`} className="link-text">
                                {room.roomName}
                            </Link>
                        </div>
                    );
                })}
            <Link to="/createRoom" >
                <button className="btn submitBtn">➕ Create</button>
            </Link>
            <Link to="/ask" >
                <button className="btn submitBtn">Ask question</button>
            </Link>

        </div>
    );

};

export default ChatRoomsList;